/**
 * Constants for farmer management
 */

// Default cost per kilogram for purchasing milk from farmers (in KES)
export const DEFAULT_COST_PER_KG = 50;

// Transaction directions for accounting
export const TRANSACTION_DIRECTION = {
  CREDIT: "credit", // Increases the account balance
  DEBIT: "debit",   // Decreases the account balance
};

// Transaction types for advances
export const ADVANCE_TRANSACTION_TYPE = {
  ADD: "add",       // Adding advance to farmer
  DEDUCT: "deduct", // Deducting from farmer's advance balance
};
